import { createEvent, createStore } from 'effector';
import {
  ChannelInstance,
  MessageInstance,
} from '@features/socket-chats-reworked/types/common';

export const $drafts = createStore<
  Record<ChannelInstance['id'], MessageInstance['text']>
>({});

export const draftChanged = createEvent<{
  channelId: ChannelInstance['id'];
  text: MessageInstance['text'];
}>();
export const draftRemoved = createEvent<ChannelInstance['id']>();
